export const STORE_CONFIG = Object.freeze({
  brand: "oreatvero",
  supportEmail: "setup@oreatvero.bar",
  operatingRegion: "Hong Kong",
  businessAddress: null,
  locale: "en-HK",
  currency: "USD",
  timeZone: "Asia/Hong_Kong",
  shippingFee: 9.99,
  paymentProvider: "Stripe",
  paymentMethodLabel: "Card via Stripe",
  orderNumberPrefix: "ORV",
  policyEffectiveDate: "4 November 2026",
});

export const CHECKOUT_COUNTRIES = Object.freeze([
  ["HK", "Hong Kong"], ["CN", "Mainland China"], ["MO", "Macao"],
  ["TW", "Taiwan"], ["SG", "Singapore"], ["JP", "Japan"],
  ["KR", "South Korea"], ["MY", "Malaysia"], ["TH", "Thailand"],
  ["PH", "Philippines"], ["ID", "Indonesia"], ["VN", "Vietnam"],
  ["AU", "Australia"], ["NZ", "New Zealand"], ["US", "United States"],
  ["CA", "Canada"], ["GB", "United Kingdom"], ["IE", "Ireland"],
  ["FR", "France"], ["DE", "Germany"], ["IT", "Italy"],
  ["ES", "Spain"], ["NL", "Netherlands"], ["BE", "Belgium"],
  ["AT", "Austria"], ["PT", "Portugal"], ["SE", "Sweden"],
  ["DK", "Denmark"], ["NO", "Norway"], ["FI", "Finland"],
  ["CH", "Switzerland"], ["AE", "United Arab Emirates"],
]);

export const formatMoney = (value) =>
  new Intl.NumberFormat(STORE_CONFIG.locale, {
    style: "currency",
    currency: STORE_CONFIG.currency,
    minimumFractionDigits: 2,
  }).format(Number(value));
